'use strict';

var AsciiText = {
    encode: encode,
    decode: decode,
};

function encode(str) {
    var length = str.length;
    var arr = new Uint8Array(length);

    for (var i = 0; i < length; i++) {
        arr[i] = str.charCodeAt(i) & 0x0ff;
    }

    return arr;
}

function decode(arr) {
    var length = arr.length;
    var chars = [];

    for (var i = 0; i < length; i++) {
        chars.push(String.fromCharCode(arr[i]));
    }

    return chars.join('');
}

module.exports = AsciiText;
